__turbopack_context__.v({
  "root": "FAQSection-module__f8gK4W__root",
});
